if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.priceWrapper = this.querySelector('[data-sticky-atc-price]');
        this.addButton = this.querySelector('[data-sticky-atc-button]');
      }

      connectedCallback() {
        this.mainProductInfo = document.querySelector('product-info[id^="MainProduct-"]');
        this.mainSectionId = this.mainProductInfo?.dataset.section;

        if (!this.mainProductInfo || !this.mainSectionId) return;

        this.observeAddToCartButton();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.mainSectionId) return;
          this.syncWithVariant(event.data.html);
        });

        this.addButton?.addEventListener('click', this.submitMainForm.bind(this));
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      observeAddToCartButton() {
        const target = this.mainProductInfo.querySelector('.product-form');
        if (!target) return;

        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
          });
        });

        this.intersectionObserver.observe(target);
      }

      syncWithVariant(html) {
        const sourcePrice = html.getElementById(`price-${this.mainSectionId}`);
        if (sourcePrice && this.priceWrapper) {
          this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }

        const sourceButton = html.getElementById(`ProductSubmitButton-${this.mainSectionId}`);
        if (sourceButton && this.addButton) {
          this.addButton.toggleAttribute('disabled', sourceButton.hasAttribute('disabled'));
        }
      }

      submitMainForm() {
        const form = document.getElementById(`product-form-${this.mainSectionId}`);
        form?.requestSubmit();
      }
    }
  );
}
